export default "__VITE_ASSET__F3IXCQDs__"